// Writes a model's like state into every cached community-gallery query that
// holds it, so a like made anywhere (a gallery card or the viewer footer) shows
// the same count on the gallery grid without a refetch. A refetch would be wrong
// here: the backend caches the index payload (including likeCount) for five
// minutes on a key that only bumps on manual admin action, so re-reading it can
// hand back a pre-like count - the like endpoint's own response is the only
// fresh count.
//
// The gallery caches one entry per filter combination (plus the popular-models
// fallback), and a caller outside the gallery cannot know which keys exist or
// which one is on screen, so this prefix-matches every 'communityGalleryModels'
// query and patches the matching slug in each. Entries without the slug are
// returned by identity, so only the cards whose props changed re-render.
export default function patchCommunityGalleryLikeCache(queryClient, { slug, liked, likeCount }) {
  if (!slug) return

  queryClient.setQueriesData({ queryKey: ['communityGalleryModels'] }, (cached) => {
    if (!cached?.pages) return cached

    let changed = false
    const pages = cached.pages.map((page) => ({
      ...page,
      items: page.items.map((item) => {
        if (item.slug !== slug) return item
        changed = true
        return { ...item, liked, likeCount }
      }),
    }))

    // Return the entry by identity when nothing matched, so react-query keeps the
    // same reference and cards in unrelated cached queries don't re-render.
    return changed ? { ...cached, pages } : cached
  })
}
